<script lang="ts" setup>
    import { ref } from 'vue';
    import { removeItemFromList, changeOrderOfListItems, getKeyValById } from './FormEditor';
    import type { AddedLists } from './FormEditor.types';
    import { List as ListsReference } from '@views/Lists/ListsTypes';
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import Collapse from '@shared/components/Collapse.vue';

    const props = defineProps<{
        lists: AddedLists;
        accountLists: ListsReference[];
    }>();

    let toggleIndex = ref<null | number>();
</script>

<template>
    <h3>{{ $Resources.FormEditorListsAddedHeading }}</h3>
    <TransitionGroup tag="ul" name="list" class="list-unstyled list-border-divider list-item-state-hover m-neg-lg-r m-neg-lg-l m-lg-b">
        <li class="p-sm-t p-lg-r p-lg-l" v-for="(list, index) in props.lists" :key="list.id">
            <div class="d-flex align-items-center">
                <h4 class="m-0-t">
                    {{ getKeyValById(list.id, props.accountLists, 'ListId', 'Name') }}
                </h4>
                <div class="m-sm-b m-auto-l text-nowrap">
                    <button
                        type="button"
                        class="btn btn-subtle btn-sm"
                        :disabled="index > 0 ? false : true"
                        @click="
                            () => {
                                toggleIndex = null;
                                changeOrderOfListItems(props.lists, index, index - 1);
                            }
                        ">
                        <i class="fa fa-arrow-up text-md" aria-hidden="true"></i>
                        <span class="sr-only">{{ $Resources.FormEditorListsAddedUpBtn }}</span>
                    </button>
                    <button
                        type="button"
                        class="btn btn-subtle btn-sm"
                        :disabled="index + 1 !== props.lists.length ? false : true"
                        @click="
                            () => {
                                toggleIndex = null;
                                changeOrderOfListItems(props.lists, index, index + 1);
                            }
                        ">
                        <i class="fa fa-arrow-down text-md" aria-hidden="true"></i>
                        <span class="sr-only">{{ $Resources.FormEditorListsAddedDownBtn }}</span>
                    </button>
                    <button type="button" class="btn btn-subtle btn-sm" @click="() => (toggleIndex !== index ? (toggleIndex = index) : (toggleIndex = null))">
                        {{ $Resources.FormEditorListsAddedEditBtn }}
                    </button>
                    <button type="button" class="btn btn-subtle btn-sm" @click="removeItemFromList(props.lists, index)">
                        {{ $Resources.FormEditorListsAddedRemoveBtn }}
                    </button>
                </div>
            </div>

            <Collapse :open="toggleIndex === index">
                <BSFormInputText class="form-group" v-model="list.label" :label="$Resources.FormEditorListsAddedLabelLabel"></BSFormInputText>
            </Collapse>
        </li>
    </TransitionGroup>
</template>

<style lang="less"></style>

<style scoped></style>
